import React from 'react';
import { Button, Result, Row } from 'antd';
import { useNavigate } from 'react-router-dom';

const UnexpectedError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Row justify='center'>
        <h1>Unexpected Error</h1>
      </Row>
      <Result
        status='error'
        title='Unexpected Error'
        subTitle='Sorry, the page you visited has an unexpected error.'
        extra={
          <Button type='primary' onClick={() => navigate('/')}>
            Back Home
          </Button>
        }
      />
    </>
  );
};

export default UnexpectedError;
